"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToString = exports.to12HourTimeFormat = exports.timeRangeToSlots = exports.formatTimeFromJSDate = exports.parseTimeNoAPM = exports.parseTimeComponents = exports.DEFAULT_RESERVATION_TIME_BUFFER = exports.SLOTS = exports.MONTHS = exports.jsToTDRWeekday = exports.MIDNIGHT_OBJ = exports.DAYSTR_FMT = exports.is24HTimeString = exports.isMonthString = exports.isDateString = exports.MONTHSTR_FMT = exports.DATESTR_FMT = void 0;
exports.addMinutesToTimeStr = addMinutesToTimeStr;
exports.dateAndTimeStrToDateTime = dateAndTimeStrToDateTime;
exports.toLuxon = toLuxon;
exports.isToday = isToday;
exports.ordinal = ordinal;
exports.dayEpoch = dayEpoch;
exports.withinTimeRange = withinTimeRange;
exports.withinWeekdays = withinWeekdays;
exports.normalizeWeekday = normalizeWeekday;
exports.getDateFromNow = getDateFromNow;
exports.someDateMatches = someDateMatches;
exports.betweenDates = betweenDates;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const toNumber_1 = __importDefault(require("lodash/toNumber"));
const pick_1 = __importDefault(require("lodash/pick"));
const findIndex_1 = __importDefault(require("lodash/findIndex"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const TDR_1 = __importStar(require("../types/TDR"));
const luxon_1 = require("luxon");
exports.DATESTR_FMT = 'yyyy-LL-dd';
exports.MONTHSTR_FMT = 'yyyy-LL';
const regExStrChecker = (exp) => {
    return (candidate) => !!candidate.match(exp);
};
const isDateString = (candidate) => {
    const dateStrRegex = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/;
    return regExStrChecker(dateStrRegex)(candidate);
};
exports.isDateString = isDateString;
const isMonthString = (candidate) => {
    const monthStrRegex = /^([12]\d{3}-(0[1-9]|1[0-2]))$/;
    return regExStrChecker(monthStrRegex)(candidate);
};
exports.isMonthString = isMonthString;
const is24HTimeString = (candidate) => {
    const timeRx = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return regExStrChecker(timeRx)(candidate);
};
exports.is24HTimeString = is24HTimeString;
exports.DAYSTR_FMT = 'MMMM dd';
exports.MIDNIGHT_OBJ = { hour: 0, minute: 0, second: 0, millisecond: 0 };
//TDR weekdays start on monday, js starts on sunday
const jsToTDRWeekday = (jsDay) => {
    return OrderedWeekdays[jsDay === 0 ? 6 : jsDay - 1];
};
exports.jsToTDRWeekday = jsToTDRWeekday;
exports.MONTHS = [
    { shortName: 'Jan', name: 'January' },
    { shortName: 'Feb', name: 'February' },
    { shortName: 'Mar', name: 'March' },
    { shortName: 'Apr', name: 'April' },
    { shortName: 'May', name: 'May' },
    { shortName: 'Jun', name: 'June' },
    { shortName: 'Jul', name: 'July' },
    { shortName: 'Aug', name: 'August' },
    { shortName: 'Sep', name: 'September' },
    { shortName: 'Oct', name: 'October' },
    { shortName: 'Nov', name: 'November' },
    { shortName: 'Dev', name: 'December' }
];
exports.SLOTS = [
    '00:00', '00:15', '00:30', '00:45', '01:00', '01:15', '01:30', '01:45', '02:00', '02:15', '02:30', '02:45', '03:00', '03:15', '03:30', '03:45',
    '04:00', '04:15', '04:30', '04:45', '05:00', '05:15', '05:30', '05:45', '06:00', '06:15', '06:30', '06:45', '07:00', '07:15', '07:30', '07:45',
    '08:00', '08:15', '08:30', '08:45', '09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45',
    '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45',
    '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00', '19:15', '19:30', '19:45',
    '20:00', '20:15', '20:30', '20:45', '21:00', '21:15', '21:30', '21:45', '22:00', '22:15', '22:30', '22:45', '23:00', '23:15', '23:30', '23:45'
];
exports.DEFAULT_RESERVATION_TIME_BUFFER = {
    minutesBefore: 120,
    minutesAfter: 120
};
const parseTimeComponents = (time) => {
    const [hour, rest] = time.split(':');
    const [minute, suffix] = rest.split(/\s+/);
    if ((0, isEmpty_1.default)(suffix)) {
        return {
            hour: (0, toNumber_1.default)(hour),
            minute: (0, toNumber_1.default)(minute)
        };
    }
    return {
        hour: (0, toNumber_1.default)(hour),
        minute: (0, toNumber_1.default)(minute),
        suffix: (suffix || '').toLowerCase().slice(0, 2)
    };
};
exports.parseTimeComponents = parseTimeComponents;
const parseTimeNoAPM = (time) => time && (0, pick_1.default)((0, exports.parseTimeComponents)(time), ['hour', 'minute']);
exports.parseTimeNoAPM = parseTimeNoAPM;
const formatTimeFromJSDate = (date, mustBe12HourFormat = false) => {
    if (!date) {
        return '';
    }
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours}:${minutes >= 10 ? minutes : `0${minutes}`}`;
    if (mustBe12HourFormat) {
        (0, exports.to12HourTimeFormat)(formattedTime);
    }
    return formattedTime;
};
exports.formatTimeFromJSDate = formatTimeFromJSDate;
const zpad = (n) => ('00' + n).slice(-2);
function norm24h(timeStr) {
    const { hour, minute, suffix } = (0, exports.parseTimeComponents)(timeStr);
    const hour24 = (suffix === 'pm' && hour < 12) ? hour + 12 : hour;
    return `${zpad(hour24)}:${zpad(minute)}`;
}
const timeRangeToSlots = (startTime, endTime) => {
    startTime = norm24h(startTime);
    let startIndex = exports.SLOTS.indexOf(startTime);
    if (startIndex === -1) {
        startIndex = (0, findIndex_1.default)(exports.SLOTS, slot => slot > startTime);
    }
    endTime = norm24h(endTime);
    let endIndex = exports.SLOTS.indexOf(endTime);
    if (endIndex === -1) {
        endIndex = (0, findIndex_1.default)(exports.SLOTS, slot => slot > endTime);
    }
    return exports.SLOTS.slice(startIndex, endIndex);
};
exports.timeRangeToSlots = timeRangeToSlots;
function addMinutesToTimeStr(timeStr, minutesToAdd) {
    const parsedTime = (0, exports.parseTimeComponents)(timeStr);
    const { hour, minute, suffix } = parsedTime;
    const is24h = !(suffix === 'pm' && hour < 12);
    const totalMinutes = minute + minutesToAdd;
    const finalMinutes = totalMinutes % 60;
    const totalHours = hour + (is24h ? 0 : 12) + Math.floor(totalMinutes / 60);
    const finalHours = totalHours % 24;
    return `${zpad(finalHours)}:${zpad(finalMinutes)}`;
}
const to12HourTimeFormat = (time, opts) => {
    if (!time) {
        return '';
    }
    const { hour, minute } = (0, exports.parseTimeComponents)(time);
    let hourNumber = Number(hour);
    let suffix = '';
    if (hourNumber === 0) {
        hourNumber = 12;
    }
    if (hourNumber > 12) {
        hourNumber = hourNumber - 12;
        suffix = 'PM';
    }
    else if (hourNumber === 12) {
        suffix = 'PM';
    }
    else {
        suffix = 'AM';
    }
    return `${hourNumber}:${(`0${minute}`).slice(-2)} ${(opts === null || opts === void 0 ? void 0 : opts.noAPM) ? '' : suffix}`.trim();
};
exports.to12HourTimeFormat = to12HourTimeFormat;
function dateAndTimeStrToDateTime(date, timeStr, timezone) {
    const { hour, minute } = (0, exports.parseTimeComponents)(timeStr);
    return luxon_1.DateTime.fromObject({
        year: date.getFullYear(),
        month: date.getMonth() + 1, // +1 because getMonth is the INDEX, not the MONTH (ie, january is 0, not 1)
        day: date.getDate(),
        hour: hour,
        minute: minute
    }, {
        zone: timezone
    });
}
function toLuxon(timestamp, zone) {
    let date = null;
    try {
        if (luxon_1.DateTime.isDateTime(timestamp)) {
            date = timestamp;
        }
        else if ((0, isNumber_1.default)(timestamp === null || timestamp === void 0 ? void 0 : timestamp.seconds)) {
            date = luxon_1.DateTime.fromSeconds(timestamp.seconds, { zone });
        }
        // apparently the translation works differently in different environments?
        // no fuckin' idea why, but cypress brings timestamp in with underscore prefixes
        else if ((0, isNumber_1.default)(timestamp === null || timestamp === void 0 ? void 0 : timestamp._seconds)) {
            date = luxon_1.DateTime.fromSeconds(timestamp._seconds, { zone });
        }
        else if ((0, isNumber_1.default)(timestamp)) {
            // sloppy test: 9999999999 in seconds is 2286-11-20, and in millis is 1970-04-26
            // if we assume that any dates we care about are inside that range, we can delineate seconds from millis
            if (timestamp > 9999999999) {
                date = luxon_1.DateTime.fromMillis(timestamp, { zone });
            }
            else {
                date = luxon_1.DateTime.fromSeconds(timestamp, { zone });
            }
        }
        if (date && date.zone.name !== zone) {
            return date.setZone(zone);
        }
        return date;
    }
    catch (e) {
        throw new Error(e);
    }
}
function isToday(date) {
    return Math.abs(toLuxon(date).diffNow('days').days) < 1;
}
const dateToString = (timestamp, zone) => {
    return toLuxon(timestamp, zone).toFormat('ff ZZZZ');
};
exports.dateToString = dateToString;
function ordinal(d) {
    if (d > 3 && d < 21) {
        return 'th';
    }
    switch (d % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
}
// as a convenience, I want to express a time (ie '12:15 pm') as seconds-since-midnight
// notice that this allows illegal times, such as '25:00', which will be returned as 'the number of seconds in 25 hours'
// which is useful to express whether 2:30 am was arrived at from the previous day
const timeStrRx = /^\s*(\d+):(\d+)(?::(\d+))?\s*(am|pm)?\s*$/;
function dayEpoch(timeStr) {
    const match = timeStr.toLowerCase().match(timeStrRx);
    if (!match) {
        return null;
    }
    const [, hourStr, minuteStr, secondStr, apm] = match;
    let hour = parseInt(hourStr);
    const minute = parseInt(minuteStr);
    const second = secondStr ? parseInt(secondStr) : 0;
    if (apm && apm === 'pm' && hour < 12) {
        hour = hour + 12;
    }
    return (hour * 60 * 60) + (minute * 60) + second;
}
function withinTimeRange(date, startTimeStr, endTimeStr) {
    const startTime = dayEpoch(startTimeStr);
    let endTime = dayEpoch(endTimeStr);
    // if we wrapped into the next day, just roll with it
    if (startTime > endTime) {
        endTime = endTime + TDR_1.SECONDS_IN_A_DAY;
    }
    let testTime = dayEpoch(`${date.hour}:${date.minute}`);
    /*
        console.log(
            "withinTimeRange",
            date.toString(), "\n",
            startTimeStr, endTimeStr, "\n",
            startTime, testTime, endTime, "\n",
            (startTime <= testTime && testTime <= endTime), "\n",
            (startTime <= (testTime + SECONDS_IN_A_DAY) && (testTime + SECONDS_IN_A_DAY) <= endTime)
        )
    */
    if (startTime <= testTime && testTime <= endTime) {
        return true;
    }
    // maybe the testTime ALSO wrapped into the next day
    testTime = testTime + TDR_1.SECONDS_IN_A_DAY;
    return startTime <= testTime && testTime <= endTime;
}
const OrderedWeekdays = [
    TDR_1.default.Weekday.Mon, TDR_1.default.Weekday.Tues, TDR_1.default.Weekday.Wed, TDR_1.default.Weekday.Thurs, TDR_1.default.Weekday.Fri,
    TDR_1.default.Weekday.Sat, TDR_1.default.Weekday.Sun
];
function withinWeekdays(date, weekdays) {
    // console.log('withinWeekdays', date.toString(), weekdays, OrderedWeekdays[date.weekday - 1]);
    if (!date) {
        return false;
    }
    return weekdays.includes(OrderedWeekdays[date.weekday - 1]);
}
function normalizeWeekday(day) {
    if (TDR_1.default.Weekday[day]) {
        return TDR_1.default.Weekday[day];
    }
    day = day.toLowerCase().trim();
    return (day.startsWith('m') ? TDR_1.default.Weekday.Mon :
        day.startsWith('tu') ? TDR_1.default.Weekday.Tues :
            day.startsWith('w') ? TDR_1.default.Weekday.Wed :
                day.startsWith('th') ? TDR_1.default.Weekday.Thurs :
                    day.startsWith('f') ? TDR_1.default.Weekday.Fri :
                        day.startsWith('sa') ? TDR_1.default.Weekday.Sat :
                            day.startsWith('su') ? TDR_1.default.Weekday.Sun :
                                null);
}
function getDateFromNow(value, unit) {
    const now = luxon_1.DateTime.now();
    let futureDate;
    switch (unit) {
        case 'seconds':
            futureDate = now.plus({ seconds: value });
            break;
        case 'hours':
            futureDate = now.plus({ hours: value });
            break;
        case 'days':
            futureDate = now.plus({ days: value });
            break;
        case 'months':
            futureDate = now.plus({ months: value });
            break;
        case 'weeks':
            futureDate = now.plus({ weeks: value });
            break;
        case 'years':
            futureDate = now.plus({ years: value });
            break;
        default:
            throw new Error('Invalid unit');
    }
    return futureDate.toJSDate();
}
function someDateMatches(date, targetDates) {
    const enusTime = date.setLocale('en-us');
    const validFormats = [
        'MMMM dd, yyyy', 'MMMM dd', 'MMMM d, yyyy', 'MMMM d',
        'MMMM',
        'yyyy-MM-dd', 'yyyy-MM-d', 'yyyy-M-dd', 'yyyy-M-d',
        'MM-dd', 'MM-d', 'M-dd', 'M-d'
    ];
    const validMatches = validFormats.map(format => enusTime.toFormat(format).toLowerCase());
    targetDates = targetDates.map(s => s.toLowerCase().trim());
    /*
    console.log('someDateMatches', {
        enusTime,
        validFormats,
        validMatches,
        targetDates,
        pass: targetDates.some(target => validMatches.includes(target))
    });
    */
    return targetDates.some(target => validMatches.includes(target));
}
function betweenDates(date, boundingDateStrs) {
    const validFormats = [
        'yyyy-MM-dd', 'yyyy-MM-d', 'yyyy-M-dd', 'yyyy-M-d',
        'MM-dd', 'MM-d', 'M-dd', 'M-d'
    ];
    const [lowerBound, upperBound] = boundingDateStrs.map(dateStr => validFormats.map(format => luxon_1.DateTime.fromFormat(dateStr, format, { locale: 'en-us' })).find(date => !date.invalidReason)).sort();
    // I realize that I'm not sure what the boundary behaviour is here
    return lowerBound && upperBound &&
        date >= lowerBound &&
        date <= upperBound;
}
//# sourceMappingURL=time.js.map